import { useLifecycle } from "@/api/hooks/use-lifecycle";

const usd = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

/** "0.125" -> "12.5%": the rate exactly (it has at most 4 decimal places). */
function percent(rate: string): string {
  return `${Number((Number(rate) * 100).toFixed(4))}%`;
}

/** Shown on every page during a Self-serve Customer's Free week (ticket 18):
 * the days left, and what the week has saved with the fee that is waived. The
 * figures are billing's own, measured to date. */
export function FreeWeekBanner() {
  const { data } = useLifecycle();
  if (!data?.free_week_ends_at || data.free_week_days_left == null) return null;

  const days = data.free_week_days_left;
  const savings = data.free_week_savings;

  return (
    <div
      data-testid="free-week-banner"
      className="mb-6 rounded-lg border border-electric-blue/40 bg-electric-blue/10 p-4 text-sm"
    >
      <p className="font-medium text-fg">
        Your Free week: {days} {days === 1 ? "day" : "days"} left.
      </p>
      {savings && (
        <p className="text-fg-muted">
          You saved {usd.format(Number(savings.saved_usd))} (measured to date); your {percent(savings.savings_fee_rate)} fee of{" "}
          {usd.format(Number(savings.fee_waived_usd))} is waived this week.
        </p>
      )}
    </div>
  );
}
